import { Link } from "react-router-dom";

import ImageRoulette from './ImageRoulette';
import logo from '../assets/logo.svg';
import bracelet from '../assets/icons/bracelet.svg';
// import gem from '../assets/icons/gem.svg';
import earrings from '../assets/icons/earrings.svg';
import necklace from '../assets/icons/necklace.svg';
// import star from '../assets/icons/star.svg';
// import swirl from '../assets/icons/swirl.svg';

const HeaderMobile = ({ color }) => {
  const icons = [
    bracelet,
    earrings,
    // gem,
    necklace,
    // star,
    // swirl,
  ]

  return (
    <div className="header-mobile center-children section collapse">
      <ImageRoulette alt="alternating fashion graphic icons" className="header-mobile-icon" images={icons} />
      <div className={`header-color header-full-screen bg bg-color-${color} bg-image-header`}></div>
      <div className="header-image header-full-screen"></div>
      <div className="header-mobile-logo-container">
        <div className={`header-mobile-strip bg bg-color-${color} bg-image-header`} />
        <div className="header-logo-image">
          <Link to="/">
            <img alt="logo" className="logo-mobile collapse" src={logo} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeaderMobile;
